import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import DiscussionsScreen from '../screen'

const GoalRoutes = () => {

    return (
        <React.Fragment>
            <Route exact path={CLIENT_ENDPOINTS.DISCUSSIONS} component={DiscussionsScreen} />
            <Route exact path={`${CLIENT_ENDPOINTS.DISCUSSIONS}/:discussionId`} component={DiscussionsScreen} />
        </React.Fragment>
    )
}

export default GoalRoutes